import { createContext, useContext } from 'react';
import { type TicketComposerStep, type TicketOpenedHandler, type TicketPrefill } from '../core/_models';

export type TicketComposerOpenOptions = {
  step?: TicketComposerStep;
  prefill?: TicketPrefill;
  origin?: string;
  onTicketOpened?: TicketOpenedHandler;
};

type TicketComposerContextValue = {
  openComposer: (options?: TicketComposerOpenOptions) => void;
};

export const TicketComposerContext = createContext<TicketComposerContextValue | undefined>(undefined);

export const useTicketComposer = (): TicketComposerContextValue => {
  const value = useContext(TicketComposerContext);
  if (!value) throw new Error('useTicketComposer must be used within TicketComposerProvider');
  return value;
};
